import { Resource } from "react-admin";
import { InstructorDetails } from "../details/InstructorDetails";
import { DefaultList } from "../misc/DefaultList";

export const instructorsResource = (
  <Resource
    key="instructors"
    name="instructors"
    list={DefaultList}
    edit={InstructorDetails}
    options={{ label: "Fahrlehrer" }}
    recordRepresentation={(instructor) => instructor.name.replaceAll(" ", "\u00A0")}
  />
);
